'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.archiveFilter = twentyninetimes.archiveFilter || function () {

	function init() {
		const archive_filter = document.getElementById('archive-filter');
		if ( archive_filter ) {
			archiveFilterFunction(archive_filter);
		}
	}

	function archiveFilterFunction(archive_filter) {
		const active_label      = archive_filter.querySelector('.active-label');
		const filters           = archive_filter.querySelectorAll('li a');
		const current_filter    = archive_filter.querySelector('li.current-cat a');

		setTimeout(function() {
		    setActiveLabelStyling(current_filter);

		    archive_filter.classList.add('active');
		}, 100);

		filters.forEach(filter => {
		    filter.addEventListener('mouseenter', function(e) {
		        e.stopPropagation();

		        var filter = e.target.closest('a');

		        if (!filter) return;

		        setActiveLabelStyling(filter);
		    });
		})

		archive_filter.querySelector('ul').addEventListener('mouseleave', function(e) {
		    var filter = e.target.closest('ul');

		    if ( !filter ) return;

		    setActiveLabelStyling(current_filter);
		});

		function setActiveLabelStyling(filter) {
		    var parentPos   = archive_filter.getBoundingClientRect(),
		        filterPos   = filter.getBoundingClientRect(),
		        filterWidth = filter.offsetWidth,
		        posLeft     = filterPos.left - parentPos.left,
		        posTop      = filterPos.top - parentPos.top;

		    active_label.style.transform = `translate3d(${posLeft}px, ${posTop}px, 0)`;
		    active_label.style.width = `${filterWidth}px`;
		}
	}

	return {
		init : init
	};

}();